import { render, staticRenderFns } from "./ResourceDetails.vue?vue&type=template&id=d05d5da0"
import script from "./ResourceDetails.vue?vue&type=script&lang=js"
export * from "./ResourceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports